module.exports = __webpack_public_path__ + "img/group-5-grey.7df45bda.svg";